
      import Delete from './delete.vue'
      import type { App, Plugin } from 'vue'

      export const DeletePlugin: Plugin = {
        install(app: App) {
          app.component('Delete', Delete)
        },
      }
      export { Delete }
      